import { css } from 'styled-components';
import {
  BreakpointQueryName,
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const jobOffersListWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.BIG, SpacingName.AUTO, 0])}
  max-width: 60rem;
`;

export const teamGrid: ThemedFunctor = ({ theme }) => css`
  flex-direction: column-reverse;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    flex-direction: row;
  }
`;

export const jobOfferSubtitle: ThemedFunctor = () => css`
    display: flex;
    align-items: center;
    gap: .25rem;
`;
